import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "@/Models/Lines/DimensionLine";

export class Ellipse extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'ellipse', dimensions );
	}

	getHeight(): Length {
		return this.cleanedPrimitives.height;
	}

	getLength(): Length {
		return this.cleanedPrimitives.height;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.width;
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'height', secondary: 'width' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		if(focusedElement.includes("cutout_measurement") || forceRender) {
			return [
				new DimensionLine( [-this.getWidth().divide(2).in_mm(), -this.getHeight().divide(2).in_mm()], [-this.getWidth().divide(2).in_mm(), this.getHeight().divide(2).in_mm() ], this.renderDimensionLabel( 'height' ), [-40, 0], ratio, this.getDimensionLineType('measurements-ellipse-height', focusedElement, forceRender) ), // Vertical line
				new DimensionLine( [-this.getWidth().divide(2).in_mm(), -this.getHeight().divide(2).in_mm()], [this.getWidth().divide(2).in_mm(), -this.getHeight().divide(2).in_mm() ], this.renderDimensionLabel( 'width' ), [0, -40], ratio, this.getDimensionLineType('measurements-ellipse-width', focusedElement, forceRender) ), // Horizontal line
			];
		}

		return [];
	}

	getDefaultDimensions(): Dimensions {
		return {
			height: 25,
			width: 50,
		};
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();
		const height = enclosingRectangle.height();

		return {
			width: width.divide(2).in_cm(),
			height: height.divide(3).in_cm(),
		};
	}
}
